import { RefObject, useEffect, useRef } from 'react'

/**
 * Fecha/dispara `onOutside` quando há um clique (mousedown/touchstart) FORA do
 * elemento referenciado. Usado nos pickers do Comparativo para fechar o dropdown
 * ao clicar fora do card. Só ativo quando `active` é true (ex.: dropdown aberto).
 */
export function useClickOutside<T extends HTMLElement>(
  ref: RefObject<T | null>,
  onOutside: () => void,
  active = true
): void {
  const cbRef = useRef(onOutside)
  cbRef.current = onOutside

  useEffect(() => {
    if (!active) return

    const handler = (event: MouseEvent | TouchEvent): void => {
      const el = ref.current
      if (el && !el.contains(event.target as Node)) {
        cbRef.current()
      }
    }

    document.addEventListener('mousedown', handler)
    document.addEventListener('touchstart', handler)
    return () => {
      document.removeEventListener('mousedown', handler)
      document.removeEventListener('touchstart', handler)
    }
  }, [ref, active])
}
